export default __webpack_public_path__ + "static/media/BaseballBat_9.76878f54.png";